import React from 'react';
import TransactionCard from './TransactionCard';
import EmptyState from './EmptyState';

type StatusKey = 'awaiting_payment' | 'processing' | 'success' | 'failed' | 'refunded' | 'expired';

interface Transaction {
  id: string;
  type: string;
  date: string;
  status: StatusKey;
  game: {
    name: string;
    image: string;
  };
  product: string;
  total: number;
}

interface TransactionListProps {
  transactions: Transaction[];
  hasSearched: boolean;
  emptyVariant?: 'default' | 'guest';
  onLogin?: () => void;
}

const TransactionList: React.FC<TransactionListProps> = ({
  transactions,
  hasSearched,
  emptyVariant = 'default',
  onLogin,
}) => {
  if (transactions.length === 0) {
    return <EmptyState variant={emptyVariant} onLogin={onLogin} />;
  }

  if (!hasSearched) {
    return <EmptyState variant={emptyVariant} onLogin={onLogin} />;
  }

  return (
    <div className="space-y-4">
      {transactions.map((transaction) => (
        <TransactionCard key={transaction.id} transaction={transaction} />
      ))}
    </div>
  );
};

export default TransactionList;
